/* Layout */
import Layout from "@/views/layout/Layout";

export default [
  {
    path: "/activityPageSet",
    component: Layout,
    alwaysShow: true,
    meta: {
      title: "自营-微页面管理",
      icon: "component"
    },
    children: [
      {
        path: "/activityPageSet/columnManage",
        component: () =>
          import("@/myviews/shoppMall/activityPageSet/columnManage/query.vue"),
        alwaysShow: false,
        name: "activityPageSetQueryColumnManage",
        meta: {
          alwaysShow: false,
          title: "栏目管理",
          icon: "component",
          have: []
        }
      },
      {
        path: "/activityPageSet/fullPlatformSetQuery",
        component: () =>
          import(
            "@/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/query.vue"
          ),
        alwaysShow: false,
        name: "activityPageSetQuery",
        meta: {
          alwaysShow: false,
          title: "微页面管理",
          icon: "component",
          roles: ["add", "modify", "viewpage"],
          have: []
        }
      },
      {
        path: "/activityPageSet/lowCodeSave",
        component: () =>
          import(
            "@/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/index.vue"
          ),
        alwaysShow: false,
        hidden: true, // 不是菜单项
        name: "lowCodeSave",
        meta: {
          alwaysShow: false,
          title: "111",
          icon: "component",
          isFullPage: true, // 全屏页面
          have: []
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/shoppMall/activityPageSet.js